import React from 'react';
import {
  Avatar,
  Badge,
  Button,
  Col,
  Divider,
  Drawer,
  Dropdown,
  Flex,
  Row,
  Space,
  Typography,
  theme,
} from 'antd';

const { Text, Title } = Typography;

const MenuMobile = ({ viewModel }) => {
  const {
    menuItems,
    menuClick,
    showMenu,
    onCloseMenu,
    accountMenu,
    workspaceName,
    userFirstName,
  } = viewModel;
  const { token } = theme.useToken();

  const level1Items = menuItems.filter((item) => !item.children || item.children.length === 0);
  const pinnedChildren = menuItems.flatMap((group) => (group.children || []).filter((child) => child.mobilePinned));
  const level2Groups = menuItems
    .filter((item) => item.children && item.children.length > 0)
    .map((group) => ({
      ...group,
      children: (group.children || []).filter((child) => !child.mobilePinned),
    }))
    .filter((group) => group.children.length > 0);

  const getItemColor = (level = 1) => {

    return token.colorPrimary;
  };

  const onMenuItemClick = (key) => {
    menuClick({ key });
  };

  const renderActionItem = (item, level = 1, fallbackIcon = null) => (
    <Col span={6} key={item.key} style={{ display: 'flex' }}>
      <Button
        type='text'
        block
        style={{
          height: '100%',
          minHeight: 92,
          whiteSpace: 'normal',
          paddingInline: 4,
          paddingBlock: 6,
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'center',
        }}
        onClick={() => onMenuItemClick(item.key)}
      >
        <Space direction='vertical' align='center' size={2} style={{ width: '100%', justifyContent: 'flex-start' }}>
          <Badge count={item.badgeCount > 99 ? '99+' : (item.badgeCount || 0)} size='small' color='#1677ff'>
            <Avatar
              size={40}
              icon={item.icon || fallbackIcon}
              style={{ backgroundColor: getItemColor(level) }}
            />
          </Badge>
          <Text
            style={{
              textAlign: 'center',
              lineHeight: 1.2,
              fontSize: 12,
              minHeight: 29,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {item.label}
          </Text>
        </Space>
      </Button>
    </Col>
  );

  return (
    <Drawer
      title={workspaceName}
      closable={{ 'aria-label': 'Close Button' }}
      onClose={onCloseMenu}
      open={showMenu}
      extra={
        <Flex justify='flex-end' style={{ width: "100%" }}>
          <div style={{ justifyContent: "center", flexDirection: "column", display: "flex", paddingRight: 16 }}>
            <Dropdown menu={accountMenu}>
              <Avatar>{userFirstName}</Avatar>
            </Dropdown>
          </div>
        </Flex>
      }
    >
      <Space direction='vertical' size={12} style={{ width: '100%' }}>
   
        {(level1Items.length > 0 || pinnedChildren.length > 0) && (
          <div>
            <Row gutter={[8, 12]}>
              {level1Items.map((item) => renderActionItem(item, 1))}
              {pinnedChildren.map((item) => renderActionItem(item, 1))}
            </Row>
          </div>
        )}

        {level2Groups.map((group, index) => (
          <div key={group.key}>

            <Divider>

              <Text strong>{group.label}</Text>
            </Divider>

            <Row gutter={[8, 12]}>
              {(group.children || []).map((child) => renderActionItem(child, 2, group.icon))}
            </Row>
          </div>
        ))}
      </Space>
    </Drawer>
  );
};

export default MenuMobile;
